module.exports = __webpack_public_path__ + "static/media/00000095_RED.764d7db2.webp";